import { Component, OnInit } from '@angular/core';
import { Empresa } from '../../../../../types/Empresa.type';
import { Nota } from '../../../../../types/Nota.type';
import { IntegradorService } from '../../../../../services/integrador.service';
import { ToastService } from '../../../../../services/toast.service';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { Processo } from '../../../../../types/Processo.type';

@Component({
  selector: 'app-notaform',
  templateUrl: './notaform.component.html',
  styleUrl: './notaform.component.css'
})
export class NotaformComponent implements OnInit {

  nota: Nota = {} as Nota
  notaCadastro: Nota = {} as Nota;
  empresas: Empresa[] = [];
  processos: Processo[] = [
    { id: 'MENSAL', nome: 'MENSAL' },
    { id: 'MENSAL_REVENDA', nome: 'MENSAL_REVENDA' },
    { id: 'MENSAL_COMPLEMENTAR', nome: 'MENSAL_COMPLEMENTAR'},
    { id: 'REVENDA_COMPLEMENTAR', nome: 'REVENDA_COMPLEMENTAR'},
    { id: 'ADIANTAMENTO', nome: 'ADIANTAMENTO'}
  ];
  processoSelecionado!: string;

  constructor(private integradorService: IntegradorService, private toastService: ToastService, private activatedRoute: ActivatedRoute, private location: Location){}

  ngOnInit(){
    this.buscaNota()
    this.buscaEmpresas();
  }

  buscaNota(){
    let id = this.activatedRoute.snapshot.paramMap.get('id');

    if(id){
      this.integradorService.getNota(id).subscribe({
        next: (data) => {
          this.nota = data
        },
        error: (error) => {
          console.error(error)
          this.toastService.erro("Erro", error.error.message)
        }
      })
    }
  }

  buscaEmpresas(){
    this.integradorService.getEmpresas().subscribe({
      next: (data) => {
        this.empresas = data
      },
      error: (error) => {
        console.error(error)
        this.toastService.erro("Erro", error.error.message)
      }
    })
  }

  salvar() {
    Object.assign(this.notaCadastro, this.nota);

    let empresaSelecionada = this.buscaEmpresaSelecionada(this.notaCadastro.empresaErp);

    if(empresaSelecionada != undefined){
      this.notaCadastro.idEmpresa = empresaSelecionada.id;
    }

    this.notaCadastro.tipoPropriedade = this.notaCadastro.tipoPropriedade?.trim() != '' ? this.notaCadastro.tipoPropriedade : null;
    this.notaCadastro.ordem = this.notaCadastro.ordem?.trim() != '' ? this.notaCadastro.ordem : null;
    this.notaCadastro.contaContabil = this.notaCadastro.contaContabil?.trim() != '' ? this.notaCadastro.contaContabil : null;
    this.notaCadastro.centroCusto = this.notaCadastro.centroCusto?.trim() != '' ? this.notaCadastro.centroCusto : null;
    this.notaCadastro.materialErp = this.notaCadastro.materialErp?.trim() != '' ? this.notaCadastro.materialErp : null;
    this.notaCadastro.cdProcesso = this.notaCadastro.cdProcesso?.trim() != '' ? this.notaCadastro.cdProcesso : null;

    if (this.nota.id) {

      this.integradorService.putNota(this.notaCadastro).subscribe({
        next: () => {
          this.toastService.sucesso('Sucesso', 'Nota atualizada com sucesso');
          this.fecharDialog();
        },
        error: (value) => {
          this.toastService.erro('Erro', 'Erro ao salvar: ' + value.error.message);
        },
      });
    } else {

      this.integradorService.postNota(this.notaCadastro).subscribe({
        next: (valor) => {
          Object.assign(this.notaCadastro, valor);
          this.toastService.sucesso('Sucesso', 'Nota salva com sucesso');
          this.fecharDialog();
        },
        error: (value) => {
          this.toastService.erro('Erro', 'Erro ao salvar: ' + value.error.message);
        },
      });
    }
  }

  buscaEmpresaSelecionada = (empresaErp: string): Empresa | undefined => {
    return this.empresas.find(empresa => empresa.empresaErp === empresaErp);
  };

  fecharDialog() {
    this.nota = {} as Nota;
    this.location.back();
  }
}
